module.exports = __webpack_public_path__ + "624dc01a4fe569f8a1345c9ddbe5321c.png";


//////////////////
// WEBPACK FOOTER
// ./ts/components/images/testerIcon.png
// module id = 864
// module chunks = 0